import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import LearningAdminModuleSeriesList from '../components/LearningAdminModuleSeriesList';
import { loadModuleSeriesAdmin } from '../../../../../state/modules/learningsAdmin/actions';
import storage from '../../../../../lib/Storage';
import store from '../../../../../state/store';
import { findStorageType } from '../../../../../lib/Auth';

const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const action = ownProps.action;
  const defaultOrder = ownProps.defaultOrderModuleSeries;
  const defaultLimit = ownProps.defaultLimitModuleSeries;
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all module series
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learningsAdmin.getIn(
        [
          'moduleSeriesAdmin',
          defaultScope,
          partnershipId,
          action,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleSeriesAdmin', x]),
              schema.learningModuleSerieAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    action,
    partnershipId,
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      action,
      filter = {},
      page = 1,
      limit,
      order,
      scope = defaultScope,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleSeriesAdmin(
          partnershipId,
          action,
          filter,
          page,
          limit,
          order,
          scope,
          (success, total, result) => {
            if (success && result) {
              const state = store.getState();

              const normalizedResult = result.map((x) => {
                return {
                  key: x,
                  ...denormalize(
                    state.entities.getIn(['learningModuleSeriesAdmin', x]),
                    schema.learningModuleSerieAdmin,
                    state.entities.toJS()
                  ),
                };
              });

              const pageCount = Math.ceil(total / limit);
              for (let i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleSeriesAdmin(
                    partnershipId,
                    action,
                    filter,
                    i,
                    limit,
                    order,
                    scope
                  )
                );
              }

              cb(true, normalizedResult);
            } else {
              cb(false, null);
            }
          }
        )
      );
    },
  };
};

const LearningAdminModuleSeriesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesList);

export default LearningAdminModuleSeriesListContainer;
